module.exports = __webpack_public_path__ + "img/request_hal.20ab28e8.svg";